<div class="container">
  <div class="columns flex-centered">
      <div class="col-12 container-ad">
          <!-- Test bannière de couleur -->
          <!-- <div class="advertisement" *ngIf="advertisementsTest && advertisementsTest.length > 0">
              <a *ngFor="let ad of advertisementsTest" (click)="handleClick(ad)">
                <div [class]="this.origin == 'OA' ? 'testOA' : 'testFO'" [style.backgroundColor]="ad.url"></div>
                <img [className]="ad?.origin" [src]="ad?.picture.url" [alt]="ad.picture.alt">
              </a>
          </div> -->

          <div class="advertisement" *ngIf="visible && advertisements && advertisements.length > 0">
            <a *ngFor="let ad of advertisements" (click)="handleClick(ad)">
                <img [className]="ad?.origin" [src]="environment.baseFileUrl + ad?.picture?.url" [alt]="ad.picture.alt">
            </a>
          </div>
      </div>
  </div>
</div>
